import React from 'react';
import ReeValidate from 'ree-validate'
import NavigationTabs from '../nav/NavigationTabs';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Button from '@material-ui/core/Button';
import ButtonContent from '../ButtonContent';
import { connect } from "react-redux";
import withAuth from '../../hocs/withAuth';
import { changeEmail, changePassword } from "../../store/actions/auth";
import { validator } from "../../validators";
import { IconButton } from '@material-ui/core';
import { convertReadbleFormat } from './../../helpers';

validator(ReeValidate);
class Preferences extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new ReeValidate({
      email: 'required|email',
      oldPassword: 'required|min:3',
    newPassword: 'required|min:3|verify_password',
      confirmPassword: 'required',
    })
    this.state = {
      email: this.props.user.email,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      confirmPassErr: '',
      formErrors: this.validator.errors,
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
    }
  }
  handleChange = field => event => {
    const name = event.target.name
    const value = event.target.value
    const { errors } = this.validator
    this.setState({ [field]: value.trim() }, () => {
      this.validateConfirmPassword();
    })
    this.validator.validate(name, value).then(() => {
      this.setState({ formErrors: errors })
    });
  }

  updateEmail() {
    let { email, formErrors } = this.state;
    !formErrors.has('email') && this.props.changeEmail(email);
  }

  validateConfirmPassword() {
    const { oldPassword, newPassword, confirmPassword } = this.state;
    let confirmPassErr = '';
    let passErr = '';
    if (oldPassword && newPassword && oldPassword === newPassword) {
      passErr = `Old and new passwords cannot be the same.`;
    }
    if (confirmPassword && newPassword && confirmPassword !== newPassword) {
      confirmPassErr = 'Confirm password does not match';
    }
    this.setState({ confirmPassErr, passErr });
  }

  changePassword() {
    let { oldPassword, newPassword, confirmPassword, passErr, confirmPassErr } = this.state;
    const { errors } = this.validator;
    if (!passErr && !confirmPassErr) {
      this.validator.validateAll({ oldPassword, newPassword, confirmPassword })
        .then(success => {
          if (success) {
            this.props.changePassword(oldPassword, newPassword).then((data) => {
              this.setState({
                newPassword: '',
                confirmPassword: '',
                oldPassword: ''
              });
            })
          } else {
            this.setState({ formErrors: errors });
          }
        })
    }
  }

  render() {
    const {
      email,
      newPassword,
      confirmPassword,
      oldPassword,
      formErrors,
      passErr,
      confirmPassErr,
      showOldPassword,
      showNewPassword,
      showConfirmPassword
    } = this.state;
    const marginClass = "-10px 0 10px 0";
    return (
      <div>
        <NavigationTabs
          title="Settings"
          set="settings"
          subtitle="Preferences"
          currentUser={this.props.currentUser}
          activeRoute="/settings/preferences" />
        <Table >
          <TableBody>
              <TableRow>
                <TableCell align="right">
                  Email:
              </TableCell>
                <TableCell align="left">
                  {email}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="right">Change Password:
                </TableCell>
                <TableCell align="left">
                <div style={{ marginTop: 20, display: 'inline-grid' }}>
                  <TextField
                      style={{ maxWidth: 400, minWidth: 300, marginRight: 10 }}
                      label="Old Password"
                      name="oldPassword"
                      value={oldPassword}
                      onChange={this.handleChange('oldPassword')}
                      margin="dense"
                      variant="outlined"
                      type={showOldPassword ? "text" : "password"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle old password visibility"
                              size="small"
                              onClick={() => this.setState({ showOldPassword: !showOldPassword })}
                              onMouseDown={e => e.preventDefault()}
                              edge="end"
                            >
                              {showOldPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {formErrors.has('oldPassword') &&
                      <span className="error text-danger" style={{ margin: marginClass }}>
                        {convertReadbleFormat(formErrors.first('oldPassword'))}</span>
                    }
                    <TextField
                      style={{ maxWidth: 400, minWidth: 300, marginRight: 10 }}
                      label="New Password"
                      name="newPassword"
                      value={newPassword}
                      onChange={this.handleChange('newPassword')}
                      margin="dense"
                      variant="outlined"
                      type={showNewPassword ? "text" : "password"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle new password visibility"
                              size="small"
                              onClick={() => this.setState({ showNewPassword: !showNewPassword })}
                              onMouseDown={e => e.preventDefault()}
                              edge="end"
                            >
                              {showNewPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {(formErrors.has('newPassword') || passErr) &&
                      <span className="error text-danger" style={{ margin: marginClass }}>
                        {(convertReadbleFormat(formErrors.first('newPassword'))) || passErr}</span>
                    }
                    <TextField
                      style={{ maxWidth: 400, minWidth: 300, marginRight: 10 }}
                      label="Confirm Password"
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={this.handleChange('confirmPassword')}
                      margin="dense"
                      variant="outlined"
                      type={showConfirmPassword ? "text" : "password"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle confirm password visibility"
                              size="small"
                              onClick={() => this.setState({ showConfirmPassword: !showConfirmPassword })}
                              onMouseDown={e => e.preventDefault()}
                              edge="end"
                            >
                              {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                    {(formErrors.has('confirmPassword') || confirmPassErr) &&
                      <span className="error text-danger" style={{ margin: marginClass }}>
                        {(formErrors.has('confirmPassword') &&
                          convertReadbleFormat(formErrors.first('confirmPassword')))
                          || confirmPassErr}</span>
                    }
                    <Button
                      onClick={() => this.changePassword()}
                      variant="contained"
                      color="primary">
                      <ButtonContent
                        text="Save"
                        icon="chevron-right" />
                    </Button>
                  </div>
                  
                </TableCell>
              </TableRow>
            </TableBody>
        </Table>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let { currentUser: { user } } = state;
  return {
    user: user
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    changeEmail: (email) => {
      return dispatch(changeEmail(email));
    },
    changePassword: (oldPassword, newPassword) => {
      return dispatch(changePassword(oldPassword, newPassword));
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withAuth(Preferences));



// WEBPACK FOOTER //
// ./src/components/settings/Preferences.js